/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataAdminStockManageListResVo } from './PageDataAdminStockManageListResVo';
import {
    PageDataAdminStockManageListResVoFromJSON,
    PageDataAdminStockManageListResVoFromJSONTyped,
    PageDataAdminStockManageListResVoToJSON,
    PageDataAdminStockManageListResVoToJSONTyped,
} from './PageDataAdminStockManageListResVo';

/**
 * 
 * @export
 * @interface ResponsePageDataAdminStockManageListResVo
 */
export interface ResponsePageDataAdminStockManageListResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataAdminStockManageListResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataAdminStockManageListResVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataAdminStockManageListResVo}
     * @memberof ResponsePageDataAdminStockManageListResVo
     */
    data?: PageDataAdminStockManageListResVo;
}

/**
 * Check if a given object implements the ResponsePageDataAdminStockManageListResVo interface.
 */
export function instanceOfResponsePageDataAdminStockManageListResVo(value: object): value is ResponsePageDataAdminStockManageListResVo {
    return true;
}

export function ResponsePageDataAdminStockManageListResVoFromJSON(json: any): ResponsePageDataAdminStockManageListResVo {
    return ResponsePageDataAdminStockManageListResVoFromJSONTyped(json, false);
}

export function ResponsePageDataAdminStockManageListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataAdminStockManageListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataAdminStockManageListResVoFromJSON(json['data']),
    };
}

export function ResponsePageDataAdminStockManageListResVoToJSON(json: any): ResponsePageDataAdminStockManageListResVo {
    return ResponsePageDataAdminStockManageListResVoToJSONTyped(json, false);
}

export function ResponsePageDataAdminStockManageListResVoToJSONTyped(value?: ResponsePageDataAdminStockManageListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataAdminStockManageListResVoToJSON(value['data']),
    };
}

